require('../../modules/es6.reflect.define-property');
module.exports = require('../../modules/_core').Reflect.defineProperty;



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/reflect/define-property.js
// module id = 959
// module chunks = 48 49 50